<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"
    class="card-item data-table-default"
    :items-per-page="itemsPerPage"
    :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm"
    :disable-sort="smAndDown"
    fixed-header
  >
    <template v-slot:footer.prepend>
      <div class="d-flex align-center ml-auto my-3">
        <div class="secondary--text text-caption">Linhas por página:</div>

        <v-select
          v-model="itemsPerPage"
          class="text-body-2 font-weight-regular rounded-lg ml-3 form-control-select"
          :items="[100, 250, 500, 1000, 2500]"
          :menu-props="{ offsetY: true }"
          append-icon="mdi-chevron-down"
          hide-details
          outlined
          dense
        >
          <template v-slot:item="{ item }">
            <v-sheet
              class="d-flex align-center justify-space-between py-1"
              color="transparent"
              width="100%"
            >
              <span class="text-caption font-weight-regular">{{ item }}</span>

              <v-icon v-if="itemsPerPage === item" color="primary" right small>
                mdi-check
              </v-icon>
            </v-sheet>
          </template>

          <template v-slot:selection="{ item }">
            <span
              class="grey--text text--darken-2 text-caption font-weight-regular text-ellipsis"
            >
              {{ item }}
            </span>
          </template>
        </v-select>
      </div>
    </template>

    <template v-for="name in Object.keys($scopedSlots)" v-slot:[name]="props">
      <slot :name="name" v-bind="props" />
    </template>
  </v-data-table>
</template>

<script>
export default {
  inheritAttrs: false,
  data: () => ({
    itemsPerPage: 1000,
  }),
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #dbdee1;

.data-table-default::v-deep {
  &.v-data-table--fixed-header {
    > .v-data-table__wrapper {
      background-color: #f3f5f6;
      border-left: 1px solid $border-color;
      border-radius: 10px 10px 0 0;
      border-right: 1px solid $border-color;

      > table {
        > thead {
          > tr {
            > th {
              background-color: #f3f5f6;
              border-bottom: 1px solid $border-color !important;
              border-top: 1px solid $border-color;
              box-shadow: none;
              color: var(--v-secondary-base);
              font-size: 14px;
              font-weight: 500;

              &:first-child {
                border-radius: 10px 0 0 0;
              }

              &:last-child {
                border-radius: 0 10px 0 0;
              }

              &.sortable {
                span {
                  margin-right: 5px;
                }

                .v-icon {
                  font-size: 14px !important;
                  margin-top: -4px;
                }
              }
            }
          }
        }

        > tbody {
          > tr {
            > td {
              background-color: #ffffff;
            }

            @media screen and (min-width: 960px) {
              &:not(:last-child),
              &:first-child {
                > td {
                  border-bottom: 1px solid $border-color;
                }
              }
            }
          }
        }
      }
    }

    > .v-data-footer {
      background-color: #f8f9fa;
      border-radius: 0 0 10px 10px;
      border: 1px solid $border-color;
      margin-right: 0;
      padding-right: 25px;

      .v-data-footer__select {
        display: none;
      }

      .form-control-select {
        background-color: #fff;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        width: 74px;

        .v-input__slot {
          padding-right: 8px;
        }

        &.v-text-field--outlined fieldset {
          border-color: $border-color;
        }

        &.v-text-field--outlined.v-input--is-focused fieldset {
          border-color: var(--v-primary-base);
        }

        input {
          min-width: 0;
          width: 0;
        }

        .v-input__append-inner {
          padding-left: 0;
        }

        .v-icon {
          color: #9e9e9e;
          font-size: 18px;
        }
      }

      .v-data-footer__pagination {
        color: var(--v-secondary-base);
        margin: 0 24px;
      }

      .v-data-footer__icons-before {
        margin-right: 6px;
      }

      .v-data-footer__icons-before,
      .v-data-footer__icons-after {
        .v-btn {
          background-color: #ffffff;
          border: 1px solid $border-color;
          border-radius: 8px;
          margin: 0;
          transition: all 0.1s linear;

          &:hover {
            border: 1px solid var(--v-primary-base);
            background-color: var(--v-primary-base);
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
